if (process.env.NODE_ENV === 'development') {
  // @ts-ignore dev-only dependency, not installed in CI prod builds
  import('react-grab')
}

/* eslint-disable zoomin/scss-import-last */
import 'core-js/es'
// Touch DnD polyfill for hybrid laptops (MapViewsSidebarListItem reorder).
import 'drag-drop-touch'
// Must precede shadcn.css so the Inter @font-face is in scope.
import '@fontsource-variable/inter'
import '@fontsource-variable/inter/wght-italic.css'
import '~/client/src/shared/shadcn.css'
import '~/client/src/shared/styles.scss'
import '~/client/src/shared/tailwind.css'
import '~/client/src/shared/tones.scss'
import '~/client/src/shared/vendor-mapbox.css'
import '~/client/src/shared/vendor.css'
import * as React from 'react'

import * as Sentry from '@sentry/browser'
import { render } from 'react-dom'

import Container from '~/client/src/desktop/container'
import DesktopRoutes from '~/client/src/desktop/desktop.routes'
import ProjectSetUpPage from '~/client/src/desktop/views/ProjectSetUp/ProjectSetUpPages'
import { ManageWorkflowTypesContext } from '~/client/src/shared/components/WorkflowTypeListSelector/ManageWorkflowTypesContext'
import * as e from '~/client/src/shared/stores/EventStore/eventConstants'
import EventContext from '~/client/src/shared/stores/EventStore/EventContext'

import App from '../shared/App'
import AppProvider from '../shared/components/AppProvider'
import Config from '../shared/Config'
import Localization from '../shared/localization/LocalizationManager'
import loadFidhubWidget from '../shared/utils/fidhubWidget'
import { beforeSend } from '../shared/utils/Sentry'
import ThemeMode from '../shared/utils/ThemeModeManager'

const eventsToHideInLog = [e.COLLECT_TELEMETRY, e.NO_EFFECT]

function startApp() {
  const environment = Config.ENVIRONMENT.toLowerCase()
  const isSentryEnabled = ['qa', 'staging', 'production'].includes(environment)

  if (isSentryEnabled) {
    Sentry.init({
      beforeSend,
      dsn: 'https://c4509968fb074001bfefc1902752cee6@sentry.io/1819303',
      environment: Config.ENVIRONMENT,
      release: `StruxHub-Desktop@${Config.VERSION}`,
      attachStacktrace: true,
    })
  }

  Localization.init()

  new App(Config).configure()
  loadFidhubWidget()

  const isTestEnv = ['qa', 'development'].includes(
    Config.ENVIRONMENT.toLowerCase(),
  )
  const container = new Container(isTestEnv)
  const { rootStore } = container
  const { eventsStore } = rootStore

  ThemeMode.init()

  if (isTestEnv) {
    window.stores = rootStore
    window.eventsLog = []

    eventsStore.addPostEventCallback(({ event }: EventContext) => {
      const [type, ...args] = event
      if (eventsToHideInLog.includes(type)) {
        return
      }
      window.eventsLog.push({ type, args })

      console.groupCollapsed(type)

      console.log(...args)

      console.groupEnd()
    })
  }

  function renderUi() {
    render(
      <AppProvider rootStore={rootStore}>
        {/* Desktop-wide handler for the inactive-workflow-type tooltip's
            "Workflow Configurator" link: open the Workflow Configurator page.
            Keeps the shared selector free of desktop navigation knowledge. */}
        <ManageWorkflowTypesContext.Provider
          value={() =>
            rootStore.projectSetUpPageStore.navigateTo(
              ProjectSetUpPage.FORM_WORKFLOWS,
            )
          }
        >
          <DesktopRoutes />
        </ManageWorkflowTypesContext.Provider>
      </AppProvider>,
      document.getElementById('app'),
    )
  }

  eventsStore.dispatchN([
    [e.START_ALL, renderUi],
    [e.LISTEN_TO_DEPLOYMENT_VERSION],
  ])
}

Config.READY.then(startApp)
